module.exports = __webpack_public_path__ + "img/phoneContact.57e39b2c.svg";